import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";

import Helpers from "../../../commons/helpers";
import useStrings from "../../../hooks/useStrings";
import Box from "../../Box";
import Button from "../../Button";
import Typography from "../../Typography";
import Filter from "../Filter";

import { DataTableProps } from "..";

export const TableFilter = <T,>({
    filterForm,
    onReset,
    onFilter,
    onCloseFilter,
    filter,
    setFilter,
    setSearch,
}: Pick<DataTableProps<T>, "filterForm" | "onReset" | "onFilter" | "onCloseFilter"> & {
    filter: boolean;
    setFilter: React.Dispatch<React.SetStateAction<boolean>>;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
}): JSX.Element => {
    const strings = useStrings();

    return (
        <Filter variant="permanent" ownerState={{ openConfigurator: filter }}>
            <Box p={2} alignItems="center">
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">{strings.Common.FILTER}</Typography>
                    <IconButton
                        style={{ padding: 0 }}
                        onClick={() => {
                            setFilter(false);
                            Helpers.isFunction(onCloseFilter) && onCloseFilter();
                        }}
                    >
                        <Close />
                    </IconButton>
                </Box>
                <Box mt={1}>{filterForm}</Box>
                <Box
                    mt={2}
                    gap={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ position: "absolute", bottom: 10, right: 0, left: 0 }}
                >
                    <Button
                        color="secondary"
                        onClick={() => {
                            setSearch("");
                            setFilter(false);
                            Helpers.isFunction(onReset) && onReset();
                        }}
                    >
                        {strings.Common.RESET}
                    </Button>
                    <Button
                        onClick={() => {
                            setFilter(false);
                            onFilter();
                        }}
                    >
                        {strings.Common.APPLY}
                    </Button>
                </Box>
            </Box>
        </Filter>
    );
};

export default TableFilter;
